<template>
    <div class="timeline-scroller d-flex align-items-center m-3">
        <span @click="scrollLeft"><i class="ico-arrow-left"></i></span>
        
        <div class="track relative">
            <ul id="scroller-time" ref="periods" class="relative d-flex">
                <li v-for="period in periods" :class="{ selected: isSelected(period), bold: isSelected(period) }" @click="select">
                    {{ period }}
                </li>
            </ul>
        </div>
        <span class="ml-auto" @click="scrollRight"><i class="ico-arrow-right"></i></span>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                scrollCount: 0,
                visibleElements: 9,
                currentScrollPos: 0,
                filteredTime: null,
                periods: ['09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', 
                    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30']
            }
        },
        computed: {
            ...mapGetters([
                'getEvents'
            ]),
            count: function() {
                var children = this.$refs.periods.children;
                return (children !== undefined) ? this.$refs.periods.children.length : 0;
            },
            liWidth: function() {
               var children = this.$refs.periods.children;
                return (children !== undefined && children.length > 0) ? children[0].offsetWidth : 0;
            },
        },
        methods: {
            ...mapActions([
                'updateNewReservationSetup',
                'clearNewReservationSetupList'
            ]),
            scrollLeft: function() {
                if (this.scrollCount > 0) {
                    this.scrollCount--;
                    this.currentScrollPos += this.liWidth;
                    this.translate(this.currentScrollPos);
                }                
            },
            scrollRight: function() {
                if (this.scrollCount <= this.count && (this.count - this.scrollCount > this.visibleElements)) {
                    this.scrollCount++;
                    this.currentScrollPos -= this.liWidth;
                    this.translate(this.currentScrollPos);
                }                                
            },
            translate: function(px) {
                this.$refs.periods.style.transform = 'translate(' + px + 'px)';
            },
            isSelected: function(period) {
                return ((period + ':00') == this.filteredTime);
            },
            select: function(e) {
                let targetTime = moment(e.currentTarget.innerHTML, 'HH:mm:ss').format('HH:mm:ss');

                let filtered = this.getEvents.filter(i => {
                    var current = moment(i.start);
                    var target = moment(this.formatDate(i.start) + ' ' + targetTime);

                    return (current.isSameOrAfter(target));
                });

                this.filteredTime = targetTime;

                // In this particular case, we can't just intersect all the events with the ones filtered
                // by timestamp: intersecting A with an empty B will output A (the full list)
                // when in fact we should be having an empty result set. So we need to make sure
                // we have items out of the filter, otherwise we'll have to set A as empty.
                // In short:
                // B has items? Intersect as normal
                // B doesn't have items? Set A as empty, because that's what should happen (no results found)

                if (filtered.length > 0) {
                    this.updateNewReservationSetup({ time: filtered });
                }
                else {
                    this.clearNewReservationSetupList();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';
    
    .timeline-scroller {
        background-color: $lighter;
        border: 1px solid $light;
        border-radius: 16px;

        > span {
            color: $dark;
            margin: 0 0.5rem;
            cursor: pointer;
        }

        .track-right {
            padding-right: 5px;
        }

        .track {
            overflow-x: hidden;
            margin: 0 6px 0 4px;
            
            ul {
                top: 0;
                left: 0;
                display: block;
                width: 100000px;
                transition: all .2s ease-in-out;
                line-height: 2.4rem;

                > li {
                    display: inline-block;
                    text-align: center;
                    color: $darker;
                    font-size: $font-size-small;
                    padding: 0 1.5rem;
                    cursor: pointer;
                    position: relative;

                    &.selected {
                        border-radius: 24px;
                        background-color: $brand;
                        border: solid 1px rgba(75, 83, 107, 0.36);
                        border-width: 1px 0;
                        color: $lightest;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// TimelineScroller.vue?789ea08c